import React, {useEffect} from 'react';
import AppPreview from "./AppPreview";

const AppPreviewV2 = (props) => {
    const { values, errors } = props;

    useEffect(() => {
        document.documentElement.style.setProperty("--app-main-color", values.mainColor);
        document.documentElement.style.setProperty("--app-text-color", values.textColor);
        document.documentElement.style.setProperty("--app-secondary-color", values.secondaryColor);
    }, [values.mainColor, values.textColor, values.secondaryColor]);

    const getImage = (propName) => {
        if(values[propName] && !errors[propName]) {
            return URL.createObjectURL(values[propName]);
        }
        return null
    }

    return (
        <AppPreview logo={getImage('logo')}
                    appleIcon={getImage('appleIcon')}
                    splash={getImage('splash')}
                    appName={values.appName}
        />
    );
};

export default AppPreviewV2;